/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React, { useState, useEffect } from 'react'
import './App.css';
import { motion } from 'framer-motion';
import NavigationRoutes from './routes';
import awsConfig from './config/aws-export';
import { Amplify, Hub, Auth } from 'aws-amplify'
import Toast from './components/Toast';
import GlobalContext from './components/Context/GloablContext';
import { useLocation, useNavigate } from 'react-router-dom';
import MandatoryToast from './components/MandatoryToast';
import { STAGE } from './config';
import { handleGroup, handleClear } from './redux/commonSlice';
import { AwsRum } from 'aws-rum-web';
import { useDispatch, useSelector } from 'react-redux';
import { setUserType,  logout,  verifyOtp  } from './pages/auth/authSlice';
import { AddBranch } from './redux/GlobalSlice';
import { CognitoCurrentData } from './CommonMethods/CognitoData';

if (STAGE === 'production' || STAGE === 'removeFS') {
    let awsRum = null;
    try {
        const config = {
            sessionSampleRate: 1,
            identityPoolId: "ap-south-1:4a791316-e0a6-407e-b281-5e96af48cb9f",
            endpoint: "https://dataplane.rum.ap-south-1.amazonaws.com",
            telemetries: ["performance", "errors", "http"],
            allowCookies: false,
            enableXRay: false
        };

        const APPLICATION_ID = 'c91a905d-8ac6-4c09-a92c-fa0124091b88';
        const APPLICATION_VERSION = '1.0.0';
        const APPLICATION_REGION = 'ap-south-1';

        awsRum = new AwsRum(
            APPLICATION_ID,
            APPLICATION_VERSION,
            APPLICATION_REGION,
            config
        );
    } catch (error) {
        // Ignore errors thrown during CloudWatch RUM web client initialization
    }
}

Amplify.configure(awsConfig);

function App(props) {
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch('')
    const [studentIdCollectFee, setStudentCollectFee] = useState("")
    const navigationPath = NavigationRoutes(props)
    const [isSideNavBar, setIsSideNavBar] = useState(false);
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const [isPageLoadingGlobal, setIsPageLoadingGlobal] = useState(false)
    const [UpdateCall, setUpdateCall] = useState(false)
    const [Toastmessage, setToastmessage] = useState('');
    const [MandatoryErrorMessage, setMandatoryErrorMessage] = useState('')
    const [swithBranch, setswithBranch] = useState(false)
    const [swithFY, setswithFY] = useState(false)
    const [reloadFY, setReloadFY] = useState(false)
    const [isBranchUpdate, setIsBranchUpdate] = useState(false)
    const [sideNavBarObj, setSideNaveBarObj] = useState([])
    const [fyBtnLoading, setFyBtnLoading] = useState(true)
    const [isInactiveBranch, setIsInactiveBranch] = useState(false)
    const [isBranchSpecifTab, setIsBranchSpecifTab]=useState(false)
    const [rolesGlobal, setRolesGlobal] = useState([])
    const [selectedBranch, setselectedBranch] = useState({})
    const [hasBranchAcess, setHasBranchAcess] = useState(false)
    const [ongoingFY, setOngoingFY] = useState({})
    const auth = useSelector(state => state.auth);
    const [fyCount, setFyCount] = useState(0)
    const { loggedIn } = auth;

    useEffect(() => {
        if (localStorage.getItem('custom:is_first_time_login') === true) {
            navigate('/reset-password')
        }
        const handleStorageChange = (event) => {
            if (event.key === 'UpdateCall') {
                setUpdateCall(JSON.parse(event.newValue)); // Sync the state with other tabs
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         if (localStorage.getItem('user')) CheckUserStatus();

    //         setRerunTheUseEffect(!rerunTheUseEffect);
    //     }, 60000);
    //     return () => {
    //         clearInterval(interval);
    //     };
    // }, [rerunTheUseEffect, UpdateCall]);


    // Whenever `UpdateCall` changes, update `localStorage` to trigger `storage` event in other tabs
    useEffect(() => {
        localStorage.setItem('UpdateCall', JSON.stringify(UpdateCall));
    }, [UpdateCall]);


    useEffect(() => {
        const branchDetails = JSON.parse(localStorage.getItem('branch_details'));
        const status = branchDetails?.status!=undefined?branchDetails.status:true;
        setIsInactiveBranch(!status) //branch status=flase means inactive, set setIsInactiveBranch as true
    },[]);
    
    /**
     * The function `handleToastClear` clears error messages and toast messages if they exist.
     */
    const handleToastClear = () => {
        if ((MandatoryErrorMessage && MandatoryErrorMessage !== '') || (Toastmessage && Toastmessage !== '') || (toastErrorMessage && toastErrorMessage !== '')) {
            setMandatoryErrorMessage('');
            setToastmessage('');
            setToastErrorMessage();
        }
    }

    useEffect(() => {
        const broadcastChannel = new BroadcastChannel('tab-reload-channel');
        const updateChannel = new BroadcastChannel('update-channel');
        const logoutChannel = new BroadcastChannel('logout-channel');
        const FYChannel = new BroadcastChannel('fy-channel');
        
        FYChannel.onmessage = (event) => {
            if (!document.hasFocus() && (event.data.type === 'fy_count')) {
                setFyCount(Number(event.data.count))
            }
            if ((event.data.type === 'fy_fail')) {
                setFyCount(0)
                setOngoingFY({})
                localStorage.removeItem("FY_details")
            }
        };
        broadcastChannel.onmessage = (event) => {
            // Avoid reloading the tab if it is the currently focused one
            if (!document.hasFocus() && (event.data.type === 'switch_fy' || event.data.type === 'switch_branch')) {
                // if (event.data.type === 'switch_fy') {
                //     navigate('/profile/my-profile');
                //     setToastmessage('Financial year switched successfully')
                // } else if (event.data.type === 'switch_branch') {
                //     navigate('/profile/my-profile');
                //     setToastmessage('Branch switched successfully')
                // }
                //const branchDetails = JSON.parse(localStorage.getItem('branch_details'))
                //const status = branchDetails?.status!=undefined?branchDetails.status:true;
                //setIsInactiveBranch(!status) //branch status=flase means inactive, set setIsInactiveBranch as true
                window.location.reload(); // Reload the tab only if it's not focused
            }
        };
        logoutChannel.onmessage = (event) => {
            if ((event.data.type === 'sessionExpire' )) {
                dispatch(handleClear())
                Auth.signOut()
                dispatch(logout());
                dispatch(AddBranch([]))
                setFyCount(0)
                setOngoingFY({})
                localStorage.removeItem("FY_details")
                if(document.hasFocus()){
                    setTimeout(() => {
                        navigate('/')
                        setToastErrorMessage('Your session has been expired')
                    }, 3000);  
                } else {
                    navigate('/')
                    setToastErrorMessage('Your session has been expired')
                }
            }
            if (!document.hasFocus() && (event.data.type === 'logout' )) {
                setFyCount(0)
                setOngoingFY({})
                localStorage.removeItem("FY_details")
                dispatch(handleClear())
                Auth.signOut()
                dispatch(logout());
                dispatch(AddBranch([]))
                navigate('/')
                setToastmessage('Sign Out successful')
            }
            if (!document.hasFocus() && (event.data.type === 'login' )) {
                const {branch, myInfo, info, email, item} = event.data.data
                dispatch(AddBranch(branch))
                localStorage.setItem('branch_details', JSON.stringify({ name: item?.name, id: item?.id }))
                localStorage.setItem('user-info', JSON.stringify(info || myInfo));
                localStorage.setItem('user', true)
                localStorage.setItem('email', email)
                dispatch(verifyOtp(email));
                setUpdateCall(!UpdateCall)
                setToastmessage('Login successfull!');
            }
        };
        updateChannel.onmessage = (event) => {
            if (event.data.type === 'updated') {
                // Get the existing financial year data from local storage
                let existingFY = JSON.parse(localStorage.getItem('FY_details')) || {};

                // Update only the properties from event.data.financiaYear while keeping other properties intact
                const updatedFY = { ...existingFY, ...event.data.financiaYear };
                
                // Check if the existing FY object has the same name as the updated FY
                if(existingFY.status === "ongoing"){
                    setOngoingFY(updatedFY);
                    localStorage.setItem('FY_details', JSON.stringify(updatedFY));
                } else if (existingFY && updatedFY.name === existingFY.name) {
                    setOngoingFY(updatedFY);
                    localStorage.setItem('FY_details', JSON.stringify(updatedFY));
                } 
                // Retrieve branch details from localStorage
                const storedBranchDetails = JSON.parse(localStorage.getItem('branch_details'));
                // Find the branch with matching id in userTypeObj.branches
                const matchedBranch = storedBranchDetails?.id && event.data.userTypeObj?.branches?.find(branch => branch?.id === storedBranchDetails?.id);
                
                dispatch(handleGroup(event.data.Roles))
                setRolesGlobal(event.data.Roles)
                setSideNaveBarObj(event.data.sideNavBarObj)
                if(event.data.userTypeObj){
                    dispatch(setUserType(event.data.userTypeObj))
                    // Update selectedBranch with matchedBranch if found
                    if (matchedBranch) {
                        setHasBranchAcess(true)
                        setselectedBranch(matchedBranch);
                        localStorage.setItem('branch_details', JSON.stringify(matchedBranch) || {})
                    } else{
                        setHasBranchAcess(false)
                        setselectedBranch(event.data.userTypeObj?.branches[0] || {})
                        localStorage.setItem('branch_details', JSON.stringify(event.data.userTypeObj?.branches[0]) || {})
                    }     
                }else{
                    setselectedBranch(event.data.branch_details)
                    localStorage.setItem('branch_details', JSON.stringify(event.data.branch_details) || {})
                }
                    
            }

            if(event.data.type === 'access-denied'){
                if (document.hasFocus() && event.data.value === true){
                    setToastErrorMessage('You are not authorized to perform this action')
                    navigate('/access-denied');
                } 
            }

        };
    
        return () => {
            broadcastChannel.close();
            updateChannel.close()
            FYChannel.close()
            logoutChannel.close() // Clean up when the component unmounts
        };
    }, []);

    useEffect(() => {
        const checkSession = async () => {
            try {
                // Check the current session
                const user = await CognitoCurrentData();
                return user
                
            } catch (error) {
                if(loggedIn){
                    const logoutChannel = new BroadcastChannel('logout-channel');
                    logoutChannel.postMessage({ type: 'sessionExpire' });
                }
            }
        };

        // Run checkSession whenever location changes
        checkSession();
        
    }, [location]);
    
    useEffect(() => {
        // Get the path from the current URL
        const path = location.pathname;
    
        // Extract the third part of the path (if it exists)
        const parts = path.split('/').filter(Boolean);
        const thirdPart = parts[0];  // 0-based index, so the third part is at index 2

        // Format the title if the third part exists
        const formattedTitle = thirdPart
            ? `SkuTeq | ${thirdPart.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())}`
            : 'SkuTeq | School Web Application';
    
        // Set the document title
        document.title = formattedTitle;
    }, [location]);

    return (
        <GlobalContext.Provider value={{
            isPageLoadingGlobal, setIsPageLoadingGlobal, setToastmessage, swithBranch, setswithBranch, swithFY, setswithFY,ongoingFY, setOngoingFY,
            Toastmessage, isSideNavBar, setIsSideNavBar, toastErrorMessage, setToastErrorMessage, sideNavBarObj, setSideNaveBarObj,fyCount, setFyCount,
            MandatoryErrorMessage, setMandatoryErrorMessage, reloadFY, setReloadFY, isBranchUpdate, setIsBranchUpdate, fyBtnLoading,
            isInactiveBranch, setIsInactiveBranch, isBranchSpecifTab, setIsBranchSpecifTab,
            studentIdCollectFee, setStudentCollectFee, rolesGlobal, setFyBtnLoading, UpdateCall, setUpdateCall, selectedBranch, setselectedBranch
        }}>
            <motion.div
                initial={{ opacity: 0 }}
                onClick={() => handleToastClear()}
                animate={{ opacity: 1 }}
            >
                {navigationPath}
                {Toastmessage !== '' && <Toast
                    message={Toastmessage}
                    type="success"
                    setToastmessage={setToastmessage} />}
                {toastErrorMessage !== '' && <Toast
                    message={toastErrorMessage}
                    type="error"
                    setToastmessage={setToastErrorMessage} />}
                <MandatoryToast />

            </motion.div>
        </GlobalContext.Provider>

    );
}

export default App;
